module.exports = {
	normal: 1 / 7,
	large: 1 / 4.5
}
